<!-- 
*****************************************************************************
**                                                                         **
** Copyright (c) 2012-2024, Tyker Technology BV                            **
** All rights reserved.                                                    **
**                                                                         **
** This software is the confidential and proprietary information of        **
** Tyker Technology BV. Unauthorized copying or disclosure of this file,   **
** via any medium is strictly prohibited. This file is only available to   **
** authorized individuals with the permission of the copyright holders.    **
** If you encounter this file and do not have permission, please contact   ** 
** the copyright holders and delete this file.                             **
**                                                                         **
***************************************************************************** 
-->

<template>
    <div class="alertArea">
        <v-alert
            dense
            :type="alert.type"
            :dismissible="alert.dismissible"
            v-on="on"
            v-for="(alert) in alerts"
            :key="alert.id"
        >
            <v-row align="center">
                <v-col class="grow">
                    {{ alert.text }}
                </v-col>
                <v-col class="shrink">
                    <v-dialog
                        v-if="alert.tooltip != ''"
                        :v-model="alert.id"
                        width="500"
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                elevation="2"
                                icon
                                v-bind="attrs"
                                v-on="on"
                            >
                                <v-icon large>
                                    mdi-help-circle-outline
                                </v-icon>
                            </v-btn>
                        </template>

                        <v-card>
                            <v-card-title>
                                {{ alert.text }}
                            </v-card-title>
                            <v-card-text>
                                {{ alert.tooltip }}
                            </v-card-text>
                        </v-card>
                    </v-dialog>
                </v-col>
            </v-row>
        </v-alert>
    </div>
</template>

<script>
export default {
    name: 'Alerts',
    data: () => ({
        on: null
    }),
    props: {
        alerts: {
            required: true
        }
    },
}
</script>

<style scoped>
.alertArea {
    position: absolute;
    bottom: 0px;
    width: 100%;
    padding-left: 10px;
    padding-right: 10px;
}

.alertArea .v-alert {
    margin-bottom: 3px;
    padding-top: 2px;
    padding-bottom: 2px;
    font-size: 1.1em;
}

.alertArea>>>.v-icon {
    margin-top: 3px;
}</style>